module.exports = __webpack_public_path__ + "static/media/counter-stuff-icon.e38bd40b.svg";